import { Provider } from 'effector-react';
import React from 'react';
import type { PageContext } from 'vike/types';

import { Container } from '@components/Container';
import { Footer } from '@components/Footer';
import { Header } from '@components/Header';

import { PageContextProvider } from './usePageContext';

import './styles/index.scss';

const PageWrapperShell = ({ children }: { children: React.ReactNode }) => <>{children}</>;

export const PageShell = ({ children, pageContext }: { children: React.ReactNode; pageContext: PageContext }) => {
	const PageWrapper = pageContext.config.PageWrapper || PageWrapperShell;
	return (
		<React.StrictMode>
			<PageContextProvider pageContext={pageContext}>
				<Provider value={pageContext.scope!}>
					<Header />
					<Container>
						<PageWrapper>{children}</PageWrapper>
					</Container>
					<Footer />
				</Provider>
			</PageContextProvider>
		</React.StrictMode>
	);
};
